var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9816 19.0174L21.9803 19.0166L17.1168 16.1171V9.7681C17.1168 8.87139 16.3909 8.1431 15.4918 8.1431C14.5947 8.1431 13.8668 8.87096 13.8668 9.7681V17.0401C13.8668 17.6134 14.1703 18.1425 14.658 18.436L14.6596 18.437L20.3146 21.8105L20.3178 21.8123C20.5773 21.9646 20.8629 22.0386 21.1468 22.0386C21.6989 22.0386 22.2381 21.755 22.543 21.2468L22.5439 21.2454C23.0035 20.4736 22.7492 19.4779 21.9816 19.0174ZM31.5 16C31.5 7.45286 24.5471 0.5 16 0.5C7.45286 0.5 0.5 7.45286 0.5 16C0.5 24.5471 7.45286 31.5 16 31.5C24.5471 31.5 31.5 24.5471 31.5 16ZM3.75 16C3.75 9.24564 9.24564 3.75 16 3.75C22.7544 3.75 28.25 9.24564 28.25 16C28.25 22.7544 22.7544 28.25 16 28.25C9.24564 28.25 3.75 22.7544 3.75 16Z",
    fill: "#C52928",
    stroke: "#C52928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.276fbfcb231cbf8805d38e5ad861a5a0.svg";
export { ForwardRef as ReactComponent };